<template>
  <div id="marketIndexArea">
    <div class="report-loader text-center" v-if="loading">
      <img src="/images/loading.gif" />
    </div>
    <div v-else>
      <div
        :style="slug === 'forecast' || preview === true ? '' : 'display:none;'"
      >
        <ForecastComponent
          :companyName="companyName"
          :consulting_slug="consulting_slug"
          :forecastTablePage="forecastTablePage"
          :forecastData="forecastData"
          :monthEnd="monthEnd"
          :tableID="'forecastTable'"
          :reportTypeId="reportTypeId"
        />
      </div>
      <div
        :style="
          slug === 'data-trends' || preview === true ? '' : 'display:none;'
        "
      >
        <DataTrendsComponent
          ref="dataTrends"
          :companyName="companyName"
          :dataTrendsData="dataTrendsData"
          :consulting_slug="consulting_slug"
          :swap="swapDataTrends"
          :reportTypeId="reportTypeId"
        />
      </div>
      <div :style="slug === 'roc' || preview === true ? '' : 'display:none;'">
        <RocComponent
          ref="roc"
          :rocData="rocData"
          :companyName="companyName"
          :consulting_slug="consulting_slug"
          :swap="swapROC"
          :reportTypeId="reportTypeId"
        />
      </div>
      <div
        v-for="(division, i) in divisions"
        v-bind:key="'division' + i"
        :style="
          slug === 'division' + i || preview === true ? '' : 'display:none;'
        "
      >
        <DivisionComparisonComponent
          ref="division"
          :divisionData="division"
          :companyName="companyName"
          :rowNumber="i"
          :report360="false"
          :chartID="'divisionChart' + i"
          :reportTypeId="reportTypeId"
        />
      </div>
      <div
        v-if="fcHistoryPage !== null"
        :style="
          slug === 'forecast-history' || preview === true ? '' : 'display:none;'
        "
      >
        <ForecastHistoryComponent
          :companyName="companyName"
          :consulting_slug="consulting_slug"
          :fcHistoryPage="fcHistoryPage"
          :report360="false"
          :tableID="'forecastHistoryTable'"
          :reportTypeId="reportTypeId"
        />
      </div>
      <div
        :style="
          slug === 'indicator-definitions' || preview === true
            ? ''
            : 'display:none;'
        "
      >
        <DefinitionOfIndicatorsComponent
          :indicatorDefinitions="indicatorDefinitions"
          :reportTypeId="reportTypeId"
        />
      </div>
      <div
        :style="
          slug === 'terminology-methodology' || preview === true
            ? ''
            : 'display:none;'
        "
      >
        <TerminologyComponent :reportTypeId="reportTypeId" />
      </div>
      <div
        :style="
          slug === 'management-objectives' || preview === true
            ? ''
            : 'display:none;'
        "
      >
        <ManagementObjectivesComponent :reportTypeId="reportTypeId" />
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import ForecastComponent from '~/components/report/modules/live-report/shared/ForecastComponent.vue';
  import DataTrendsComponent from '~/components/report/modules/live-report/shared/DataTrendsComponent.vue';
  import DivisionComparisonComponent from '~/components/report/modules/live-report/shared/DivisionComparisonComponent.vue';
  import ForecastHistoryComponent from '~/components/report/modules/live-report/shared/ForecastHistoryComponent.vue';
  import DefinitionOfIndicatorsComponent from '~/components/report/modules/live-report/shared/DefinitionOfIndicatorsComponent.vue';
  import ManagementObjectivesComponent from '~/components/report/modules/live-report/shared/ManagementObjectivesComponent.vue';
  import TerminologyComponent from '~/components/report/modules/live-report/shared/TerminologyComponent.vue';
  import RocComponent from '~/components/report/modules/live-report/shared/ROCComponent.vue';
  import pptxgen from 'pptxgenjs';
  import pdfMake from 'pdfmake/build/pdfmake';
  import pdfFonts from 'pdfmake/build/vfs_fonts';

  export default {
    name: 'MarketIndexComponent',
    props: {
      slug: {
        type: String,
        default: '',
      },
      index: {
        type: [Number, String],
        default: '',
      },
      preview: {
        type: Boolean,
        default: false,
      },
      consulting_slug: {
        type: String,
        default: '',
      },
      apiResponse: {
        type: Object,
        default: () => ({}),
      },
      reportID: {
        type: [Number, String],
        default: '',
      },
      reportTypeId: {
        type: [Number, String],
        default: '',
      },
    },
    components: {
      ForecastComponent,
      ForecastHistoryComponent,
      DataTrendsComponent,
      DivisionComparisonComponent,
      DefinitionOfIndicatorsComponent,
      ManagementObjectivesComponent,
      TerminologyComponent,
      RocComponent,
    },
    data() {
      return {
        //sends all API variables used in MI
        loading: true,
        companyName: '',
        productType: '',
        forecastTablePage: {},
        dataTrendsData: {},
        indicatorDefinitions: {
          evenRows: [],
          oddRows: [],
          definitions: [],
        },
        rocData: {},
        divisions: [],
        currentYear: new Date().getFullYear(),
        swapDataTrends: false,
        swapROC: false,
        forecastData: {},
        forecastBar: '',
        wasRevised: '',
        wasRevised1: '',
        wasRevised2: '',
        wasRevised3: '',
        fcHistoryPage: null,
        monthEnd: [],
      };
    },
    mounted() {
      this.setData();
      var divW = jQuery('#marketIndexArea').width();
      setInterval(function () {
        var w = jQuery('#marketIndexArea').width();
        if (w != divW) {
          $('#forecastTable').DataTable().columns.adjust();
          divW = w;
        }
      }, 100);
    },
    updated() {
      if (!this.preview) {
        if (this.slug === 'data-trends') {
          Plotly.Plots.resize('dataTrendsChart');
        } else if (this.slug === 'roc') {
          Plotly.Plots.resize('rocChart');
        } else if (this.slug === 'division' + this.index) {
          Plotly.Plots.resize('divisionChart' + this.index);
        } else if (this.slug === 'forecast') {
          $('#forecastTable').DataTable().columns.adjust();
        }
      }
      //adjusts chart size by calling to plotly method with id of chart
    },
    methods: {
      async getReportLogo() {
        let companyLogoImage = await this.getOnlyCompanyLogo();

        if (!companyLogoImage) {
          companyLogoImage = this.getBase64Image(
            document.getElementById('itrLogo')
          );
        }

        return companyLogoImage;
      },
      async getOnlyCompanyLogo() {
        let companyLogoImage = null;

        try {
          const { data } = await axios.get(
            `/company-logo/report/${this.reportID}/image-data-url`
          );
          companyLogoImage = data;
        } catch (error) {
          //
        }

        return companyLogoImage;
      },
      setData() {
        this.companyName = this.apiResponse.CompanyName ?? '';
        this.productType = this.apiResponse.CoverPage.ProductType ?? '';
        this.forecastBar =
          this.apiResponse.ForecastTablePage.ForecastRevisedText ?? '';

        //definition page
        this.indicatorDefinitions = {
          evenRows: [],
          oddRows: [],
          definitions:
            this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows,
        };

        //loop and set even and odds
        for (
          let i = 0;
          i <
          this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows
            .length;
          ++i
        ) {
          if (i % 2 === 0) {
            this.indicatorDefinitions.evenRows.push(
              this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows[i]
            );
          } else {
            this.indicatorDefinitions.oddRows.push(
              this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows[i]
            );
          }
        }

        //data trends
        this.dataTrendsData = this.apiResponse.DataTrendsPage;
        this.swapDataTrends = this.apiResponse.DataTrendsPage.IsSwapped;

        //roc data
        this.rocData = this.apiResponse.RoCPage;
        this.swapROC = this.apiResponse.RoCPage.IsSwapped;

        //forecast
        this.forecastData = this.apiResponse.ForecastTablePage;

        //forecast history
        this.fcHistoryPage = this.apiResponse.FCHistoryPage ?? null;
        if (this.fcHistoryPage !== null && this.slug === 'forecast-history') {
          this.wasRevised1 =
            this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1;
          this.wasRevised2 =
            this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2;
          this.wasRevised3 =
            this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3;
        }

        var monthArray = [];
        var monthArrayFinal = [];
        for (
          let i = 0;
          i < this.apiResponse.ForecastTablePage.ForecastTable.Headers.length;
          ++i
        ) {
          monthArray.push(
            this.apiResponse.ForecastTablePage.ForecastTable.Headers[i].replace(
              /[0-9]/g,
              ''
            )
          );
          monthArrayFinal.push(monthArray[i].replace(/-/g, ''));
        }

        this.monthEnd = monthArrayFinal;

        this.divisions = this.apiResponse.RoCDivPages;

        this.buildPageDropDownMenu();
      },
      buildPageDropDownMenu: function () {
        var pages = document.getElementById('report-page');
        pages.innerHTML = '';

        //forecast
        var forecast = document.createElement('option');
        forecast.text = 'Forecast';
        forecast.value = 'forecast';
        forecast.selected = this.slug === 'forecast' || this.slug === '';
        pages.add(forecast);

        //map data trends
        var dataTrends = document.createElement('option');
        dataTrends.text = 'Data Trends';
        dataTrends.value = 'data-trends';
        dataTrends.selected = this.slug === 'data-trends';
        pages.add(dataTrends);

        //map roc
        var roc = document.createElement('option');
        roc.text = 'Rates-of-Change';
        roc.value = 'roc';
        roc.selected = this.slug === 'roc';
        pages.add(roc);

        //map division
        if (this.apiResponse.RoCDivPages) {
          for (let i = 0; i < this.apiResponse.RoCDivPages.length; ++i) {
            var divPage = document.createElement('option');
            divPage.text =
              'Division Comparison - ' +
              this.apiResponse.RoCDivPages[i].OtherSeriesName;
            divPage.value = 'division' + i;
            divPage.selected = this.slug === 'division' + i;
            divPage.setAttribute('index', i);
            pages.add(divPage);
          }
        }

        //forecast history
        if (this.apiResponse.FCHistoryPage !== null) {
          var forecastHistory = document.createElement('option');
          forecastHistory.text = 'Forecast History';
          forecastHistory.value = 'forecast-history';
          forecastHistory.selected = this.slug === 'forecast-history';
          pages.add(forecastHistory);
        }

        //map definitions
        var definitions = document.createElement('option');
        definitions.text = 'Indicator Definitions';
        definitions.value = 'indicator-definitions';
        definitions.selected = this.slug === 'indicator-definitions';
        pages.add(definitions);

        //terminology
        var terminology = document.createElement('option');
        terminology.text = 'Terminology And Methodology';
        terminology.value = 'terminology-methodology';
        terminology.selected = this.slug === 'terminology-methodology';
        pages.add(terminology);

        //management objective
        var management = document.createElement('option');
        management.text = 'Management Objectives';
        management.value = 'management-objectives';
        management.selected = this.slug === 'management-objectives';
        pages.add(management);

        if (!this.preview) {
          //handle paginations
          document.getElementById('paginationPagesLabel').innerHTML =
            pages.selectedIndex + 1 + '/' + pages.length;
        }

        this.loading = false;
      },
      async downloadPDF() {
        var companyName = this.apiResponse.CompanyName;
        pdfMake.vfs = pdfFonts;

        let companyLogoImageDataUrl = await this.getOnlyCompanyLogo();
        if (!companyLogoImageDataUrl) {
          companyLogoImageDataUrl = 'itrLogo';
        }

        let companyNameFontSize = 30;
        if (companyName.length >= 70) {
          companyNameFontSize = 10;
        } else if (companyName.length >= 40) {
          companyNameFontSize = 12;
        } else if (companyName.length >= 20) {
          companyNameFontSize = 18;
        } else if (companyName.length >= 15) {
          companyNameFontSize = 25;
        }

        let tableTitleFontSize = 30;
        if (this.apiResponse.ForecastTablePage.TableTitle.length >= 70) {
          tableTitleFontSize = 10;
        } else if (this.apiResponse.ForecastTablePage.TableTitle.length >= 40) {
          tableTitleFontSize = 12;
        } else if (this.apiResponse.ForecastTablePage.TableTitle.length >= 20) {
          tableTitleFontSize = 18;
        } else if (this.apiResponse.ForecastTablePage.TableTitle.length >= 15) {
          tableTitleFontSize = 25;
        }

        let fcHistoryTitleFontSize = 30;
        if (this.apiResponse.FCHistoryPage !== null) {
          if (this.apiResponse.FCHistoryPage.PageTitle.length >= 70) {
            fcHistoryTitleFontSize = 10;
          } else if (this.apiResponse.FCHistoryPage.PageTitle.length >= 40) {
            fcHistoryTitleFontSize = 12;
          } else if (this.apiResponse.FCHistoryPage.PageTitle.length >= 20) {
            fcHistoryTitleFontSize = 18;
          } else if (this.apiResponse.FCHistoryPage.PageTitle.length >= 15) {
            fcHistoryTitleFontSize = 25;
          }
        }

        //create cover page chart
        await this.createCoverPageChart();

        //create cover page
        var coverPage = [
          {
            // width: 150,
            // height: 50,
            fit: [200, 200],
            alignment: 'center',
            image: 'itrLogo',
            margin: [0, 0, 0, 15],
          },
          {
            text: this.apiResponse.CoverPage.ProductType,
            fontSize: 62,
            alignment: 'center',
            bold: true,
            italics: true,
            style: 'darkBlue',
            margin: [0, 0, 0, 15],
          },
          {
            text: [
              '=====================================================     ',
              {
                text: this.apiResponse.CoverPage.ReportDate,
              },
              '     ==========',
            ],
            style: 'darkBlue',
            alignment: 'center',
            margin: [0, 0, 0, 15],
          },
          {
            text: this.apiResponse.CompanyName,
            style: 'darkBlue',
            bold: true,
            alignment: 'center',
            fontSize: 14,
          },
          {
            //pushed image of chart to pdf page
            image: await Plotly.toImage('coverPageChart', {
              format: 'png',
              width: 800,
              height: 600,
            }),
            height: 150,
            width: 300,
            alignment: 'center',
          },
          //phases area
          {
            margin: [200, 20, 0, 15],
            alignment: 'center',
            columnGap: 5,
            columns: [
              {
                image: 'phaseAFull',
                height: 50,
                width: 85,
                alignment: 'center',
              },
              {
                image: 'phaseBFull',
                height: 50,
                width: 85,
                alignment: 'center',
              },
              {
                image: 'phaseCFull',
                height: 50,
                width: 85,
                alignment: 'center',
              },
              {
                image: 'phaseDFull',
                height: 50,
                width: 85,
                alignment: 'center',
              },
            ],
          },
          //footer area with contact info
          {
            bold: true,
            style: 'darkBlue',
            text: '603.796.2500 | reports@itreconomics.com',
            alignment: 'center',
          },
          //footer area with aditional text
          {
            bold: true,
            style: 'darkBlue',
            text: 'www.itrondemand.com',
            link: 'https://www.itrondemand.com',
            alignment: 'center',
          },
        ];

        {
          //forecast
          if (this.apiResponse.ForecastTablePage !== null) {
            //sets layout of forecast pdf page
            var forecastPage = [
              {
                pageBreak: 'before',
                columnGap: 5,
                columns: [
                  {
                    fit: [100, 100],
                    image: this.getBase64Image(
                      document.getElementById('itrLogo')
                    ),
                  },
                  {
                    width: '65%',
                    alignment: 'center',
                    fontSize: 14,
                    bold: true,
                    text: this.apiResponse.ForecastTablePage.TableTitle,
                  },
                  {
                    fit: [100, 100],
                    alignment: 'right',
                    image: companyLogoImageDataUrl,
                  },
                ],
              },
            ];
            // forecast table pushed to pdf
            var forecastPageTable = {
              layout: 'lightHorizontalLines',
              margin: [0, 10, 0, 10],
              fontSize: 7,
              table: {
                headerRows: 1,
                widths: [],
                body: [],
              },
            };
            //
            let longForecast = false;
            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length >
                0 &&
              this.apiResponse.ForecastTablePage.ForecastTable.Rows[0]
                .ForecastColumns.length > 13
            ) {
              longForecast = true;
              forecastPageTable.fontSize = 4;
              forecastPageTable.margin = [-20, 10, -10, 10];
            }

            var fcTableHeaders = [];
            for (
              let i = 0;
              i <
              this.apiResponse.ForecastTablePage.ForecastTable.Headers.length;
              i++
            ) {
              const element =
                this.apiResponse.ForecastTablePage.ForecastTable.Headers[i];
              var headerIndex = i;
              var fiscalMonthEnd =
                this.apiResponse.ForecastTablePage.FiscalYearEndMonth;
              var monthEnd = this.monthEnd[headerIndex];

              //pushes table headers if long forecast or first column hidden
              if (
                i === 1 &&
                this.apiResponse.ForecastTablePage.HideFirstColumn
              ) {
                if (
                  headerIndex === 1 &&
                  this.apiResponse.ForecastTablePage.ForecastRevised
                ) {
                  if (
                    monthEnd === fiscalMonthEnd &&
                    this.apiResponse.ForecastTablePage.ForecastTable.Headers
                      .length -
                      1 !==
                      headerIndex
                  ) {
                    forecastPageTable.table.widths.push('auto');
                    fcTableHeaders.push({
                      text: '|',
                      fillColor: '#FFF',
                      color: '#FFF',
                    });
                  } else {
                    forecastPageTable.table.widths.push('auto');
                    fcTableHeaders.push({
                      text: '|',
                      fillColor: '#FFF',
                      color: '#FFF',
                    });
                  }
                } else if (
                  monthEnd === fiscalMonthEnd &&
                  this.apiResponse.ForecastTablePage.ForecastTable.Headers
                    .length -
                    1 !==
                    headerIndex
                ) {
                  forecastPageTable.table.widths.push('auto');
                  fcTableHeaders.push({
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                  });
                }
              } else {
                if (element === '') {
                  fcTableHeaders.push({
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                  });
                } else {
                  fcTableHeaders.push(element);
                }

                if (
                  headerIndex === 1 &&
                  this.apiResponse.ForecastTablePage.ForecastRevised
                ) {
                  if (
                    monthEnd === fiscalMonthEnd &&
                    this.apiResponse.ForecastTablePage.ForecastTable.Headers
                      .length -
                      1 !==
                      headerIndex
                  ) {
                    forecastPageTable.table.widths.push('auto');
                    fcTableHeaders.push({
                      text: '|',
                      fillColor: '#FFF',
                      color: '#FFF',
                    });
                  } else {
                    forecastPageTable.table.widths.push('auto');
                    fcTableHeaders.push({
                      text: '|',
                      fillColor: '#FFF',
                      color: '#FFF',
                    });
                  }
                } else if (
                  monthEnd === fiscalMonthEnd &&
                  this.apiResponse.ForecastTablePage.ForecastTable.Headers
                    .length -
                    1 !==
                    headerIndex
                ) {
                  forecastPageTable.table.widths.push('auto');
                  fcTableHeaders.push({
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                  });
                }

                //sets width of table headers if longForecast
                if (i === 0) {
                  if (longForecast) {
                    forecastPageTable.table.widths.push(60);
                  } else {
                    forecastPageTable.table.widths.push(100);
                  }
                } else {
                  if (
                    monthEnd === fiscalMonthEnd &&
                    this.apiResponse.ForecastTablePage.ForecastTable.Headers
                      .length -
                      1 !==
                      headerIndex
                  ) {
                    forecastPageTable.table.widths.push(5);
                  } else {
                    forecastPageTable.table.widths.push('auto');
                  }
                }
              }
            }

            forecastPageTable.table.body.push(fcTableHeaders);

            for (
              let i = 0;
              i < this.apiResponse.ForecastTablePage.ForecastTable.Rows.length;
              i++
            ) {
              const row =
                this.apiResponse.ForecastTablePage.ForecastTable.Rows[i];

              var index = i;
              var actuals = parseFloat(
                this.forecastData.ForecastTable.Rows[7].ForecastColumns[0]
              );
              var lowerRange = parseFloat(
                this.forecastData.ForecastTable.Rows[4].ForecastColumns[0]
              );
              var upperRange = parseFloat(
                this.forecastData.ForecastTable.Rows[6].ForecastColumns[0]
              );

              if (
                i > 0 &&
                this.apiResponse.ForecastTablePage.ForecastTable.Rows[i - 1]
                  .RowTitle === 'Actual'
              ) {
                var tempRows = this.buildEmptyForecastRow();
                forecastPageTable.table.body.push(tempRows);
              }

              // pushed row data to table in pdf
              var fcRow = [
                {
                  text: row.RowTitle,
                  alignment: 'center',
                  bold:
                    row.RowTitle === 'Actual' ||
                    row.RowTitle.includes('Annual') ||
                    row.RowTitle.includes('Quarterly')
                      ? true
                      : false,
                },
              ];

              for (let x = 0; x < row.ForecastColumns.length; x++) {
                const element = row.ForecastColumns[x];

                if (
                  x === 0 &&
                  this.apiResponse.ForecastTablePage.HideFirstColumn
                )
                  continue;

                if (
                  x === 1 &&
                  this.apiResponse.ForecastTablePage.ForecastRevised
                ) {
                  // forecast revised table styling
                  if (this.forecastBar === 'Forecast Revised') {
                    fcRow.push({
                      // fit: [80, 200],
                      width: 10,
                      height: 200,
                      image: this.getBase64Image(
                        document.getElementById('forecastRevisedBar')
                      ),
                      rowSpan:
                        this.apiResponse.ForecastTablePage.ForecastTable.Rows
                          .length === 16
                          ? this.apiResponse.ForecastTablePage.ForecastTable
                              .Rows.length + 3
                          : this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length >= 14
                            ? this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length + 3
                            : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length >= 12
                              ? this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2
                              : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2,
                    });
                  } else if (this.forecastBar === 'Data Trends Adjusted') {
                    // datatrends revised table styling
                    fcRow.push({
                      // fit: [100, 200],
                      width: 10,
                      height: 200,
                      image: this.getBase64Image(
                        document.getElementById('dataTrendsBar')
                      ),
                      rowSpan:
                        this.apiResponse.ForecastTablePage.ForecastTable.Rows
                          .length === 16
                          ? this.apiResponse.ForecastTablePage.ForecastTable
                              .Rows.length + 3
                          : this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length >= 14
                            ? this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length + 3
                            : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length >= 12
                              ? this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2
                              : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2,
                    });
                  } else if (this.forecastBar === 'Rates-of-Change Adjusted') {
                    // datatrends revised table styling
                    fcRow.push({
                      // fit: [100, 200],
                      width: 10,
                      height: 200,
                      image: this.getBase64Image(
                        document.getElementById('ratesOfChangeBar')
                      ),
                      rowSpan:
                        this.apiResponse.ForecastTablePage.ForecastTable.Rows
                          .length === 16
                          ? this.apiResponse.ForecastTablePage.ForecastTable
                              .Rows.length + 3
                          : this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length >= 14
                            ? this.apiResponse.ForecastTablePage.ForecastTable
                                .Rows.length + 3
                            : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length >= 12
                              ? this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2
                              : this.apiResponse.ForecastTablePage.ForecastTable
                                  .Rows.length + 2,
                    });
                  }
                } else if (
                  this.monthEnd[x] ===
                    this.apiResponse.ForecastTablePage.FiscalYearEndMonth &&
                  this.apiResponse.ForecastTablePage.ForecastTable.Headers
                    .length -
                    1 !==
                    x
                ) {
                  // pushes empty rows to table
                  fcRow.push({
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                  });
                }

                // sets coloring of actual
                if (row.RowTitle === 'Actual') {
                  fcRow.push({
                    text: element,
                    alignment: 'center',
                    bold: true,
                    color:
                      actuals >= lowerRange && actuals <= upperRange
                        ? '#09A684'
                        : '#D2232A',
                  });
                } else {
                  fcRow.push({
                    text: element,
                    alignment: 'center',
                    bold:
                      row.RowTitle.includes('Annual') ||
                      row.RowTitle.includes('Quarterly')
                        ? true
                        : false,
                  });
                }
              }

              forecastPageTable.table.body.push(fcRow);
            }
            forecastPage.push(forecastPageTable);

            //outlook text box
            var outlookText = {
              margin: [0, 0, 0, 10],
              fontSize: 10,
              table: {
                heights: [0, 140, 0, 0],
                headerRows: 1,
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Outlook',
                      fillColor: '#65A9D2',
                      color: '#FFF',
                      // alignment: 'center'
                    },
                  ],
                  // [{
                  //     ul: [
                  //         this.apiResponse.ForecastTablePage.Outlook
                  //     ]
                  // }]
                ],
              },
              layout: {
                hLineColor: function () {
                  return '#65A9D2';
                },
                vLineColor: function () {
                  return '#65A9D2';
                },
              },
            };

            //outlook text box
            var outlookUL = [];
            for (
              let i = 0;
              i < this.apiResponse.ForecastTablePage.Outlook.length;
              i++
            ) {
              const element = this.apiResponse.ForecastTablePage.Outlook[i];
              outlookUL.push(element);
            }
            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length > 0
            ) {
              outlookText.table.body.push([
                {
                  ul: outlookUL,
                },
              ]);
            }

            // forecastPage.push(outlookText);

            var resultsText = {
              margin: [0, 0, 0, 10],
              fontSize: 10,
              table: {
                heights: [0, 140, 0, 0],
                headerRows: 1,
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Results',
                      fillColor: '#5AB5A2',
                      color: '#FFF',
                      // alignment: 'center'
                    },
                  ],
                  // [{
                  //     ul: [
                  //         this.apiResponse.ForecastTablePage.Outlook
                  //     ]
                  // }]
                ],
              },
              layout: {
                hLineColor: function () {
                  return '#5AB5A2';
                },
                vLineColor: function () {
                  return '#5AB5A2';
                },
              },
            };

            var resultsUL = [];
            for (
              let i = 0;
              i < this.apiResponse.ForecastTablePage.Results.length;
              i++
            ) {
              const element = this.apiResponse.ForecastTablePage.Results[i];
              resultsUL.push(element);
            }
            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length > 0
            ) {
              resultsText.table.body.push([
                {
                  ul: resultsUL,
                },
              ]);
            }

            // forecastPage.push(resultsText);

            var evidence = {
              margin: [0, 0, 0, 10],
              fontSize: 10,
              table: {
                heights: [0, 140, 0, 0],
                headerRows: 1,
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Supporting Evidence',
                      fillColor: '#183961',
                      color: '#FFF',
                      // alignment: 'center'
                    },
                  ],
                ],
              },
              layout: {
                hLineColor: function () {
                  return '#183961';
                },
                vLineColor: function () {
                  return '#183961';
                },
              },
            };

            var evidenceUL = [];
            for (
              let i = 0;
              i < this.apiResponse.ForecastTablePage.Evidence.length;
              i++
            ) {
              const element = this.apiResponse.ForecastTablePage.Evidence[i];
              evidenceUL.push(element);
            }
            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length > 0
            ) {
              evidence.table.body.push([
                {
                  ul: evidenceUL,
                },
              ]);
            }

            // forecastPage.push(evidence);

            var risks = {
              margin: [0, 0, 0, 10],
              fontSize: 10,
              table: {
                heights: [0, 140, 0, 0],
                headerRows: 1,
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Risks',
                      fillColor: '#006742',
                      color: '#FFF',
                      // alignment: 'center'
                    },
                  ],
                ],
              },
              layout: {
                hLineColor: function () {
                  return '#006742';
                },
                vLineColor: function () {
                  return '#006742';
                },
              },
            };

            var risksUL = [];
            for (
              let i = 0;
              i < this.apiResponse.ForecastTablePage.Risks.length;
              i++
            ) {
              const element = this.apiResponse.ForecastTablePage.Risks[i];
              risksUL.push(element);
            }
            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length > 0
            ) {
              risks.table.body.push([
                {
                  ul: risksUL,
                },
              ]);
            }
            // forecastPage.push(risks);

            var forecastTextColumns = [
              {
                columnGap: 5,
                columns: [outlookText, resultsText, evidence, risks],
              },
            ];

            if (
              this.apiResponse.ForecastTablePage.ForecastTable.Rows.length > 0
            ) {
              forecastPage.push(forecastTextColumns);
            }
          }
        } //Forecast end

        {
          //start data trends
          var dataTrends = [
            {
              pageBreak: 'before',
              text: this.apiResponse.DataTrendsPage.CompanyName,
              alignment: 'center',
              fontSize: 14,
              bold: true,
            },
            {
              text: 'Data Trends, ' + this.apiResponse.DataTrendsPage.DataLabel,
              alignment: 'center',
              fontSize: 10,
              margin: [0, 0, 0, 0],
            },
          ];

          //add chart image
          dataTrends.push({
            columnGap: 10,
            columns: [
              {
                // image: await this.$refs.dataTrends.pushToImage(800, 500),
                image: $('#dataTrendsChartImg').attr('src'),
                width: 600,
                height: 400,
              },
              [
                {
                  text: this.apiResponse.DataTrendsPage.Last3MMLabel,
                  alignment: 'center',
                  fontSize: 14,
                  margin: [0, 10, 0, 10],
                },
                {
                  text: this.apiResponse.DataTrendsPage.Last3MM,
                  alignment: 'center',
                  color: this.apiResponse.DataTrendsPage.IsSwapped
                    ? '#183961'
                    : '#65A9D2',
                  fontSize: 16,
                  bold: true,
                  margin: [0, 0, 0, 20],
                },
                {
                  text: this.apiResponse.DataTrendsPage.Last12MMLabel,
                  alignment: 'center',
                  fontSize: 14,
                  margin: [0, 0, 0, 10],
                },
                {
                  text: this.apiResponse.DataTrendsPage.Last12MM,
                  alignment: 'center',
                  color: this.apiResponse.DataTrendsPage.IsSwapped
                    ? '#65A9D2'
                    : '#183961',
                  fontSize: 16,
                  bold: true,
                  margin: [0, 0, 0, 30],
                },
                {
                  text: 'OUTLOOK',
                  fontSize: 14,
                  alignment: 'center',
                  bold: true,
                  margin: [0, 0, 0, 5],
                },
                {
                  text: this.apiResponse.DataTrendsPage.Outlook,
                  fontSize: 12,
                  alignment: 'center',
                },
              ],
            ],
          });

          //add dt table
          var dtTable = {
            layout: 'lightHorizontalLines',
            margin: [0, 0, 0, 0],
            fontSize: 6,
            table: {
              headerRows: 1,
              widths: ['auto'],
              body: [],
              alignment: 'center',
            },
          };

          var dtHeader = [
            {
              text: this.apiResponse.DataTrendsPage.DataTrendsTable.Row1Title,
              alignment: 'center',
            },
          ];
          var dtLMR = [
            {
              text: this.apiResponse.DataTrendsPage.DataTrendsTable.Row2Title,
              alignment: 'center',
            },
          ];
          var dtMedian = [
            {
              text: this.apiResponse.DataTrendsPage.DataTrendsTable.Row3Title,
              alignment: 'center',
              bold: true,
            },
          ];
          var dtUMR = [
            {
              text: this.apiResponse.DataTrendsPage.DataTrendsTable.Row4Title,
              alignment: 'center',
            },
          ];
          //loop othrough dt data
          for (
            let i = 0;
            i < this.apiResponse.DataTrendsPage.DataTrendsTable.Columns.length;
            i++
          ) {
            const element =
              this.apiResponse.DataTrendsPage.DataTrendsTable.Columns[i];
            dtTable.table.widths.push('*');
            dtHeader.push({
              text: element.MonthYear,
              alignment: 'center',
            });
            dtLMR.push({
              text: element.LMR,
              alignment: 'center',
            });
            dtMedian.push({
              text: element.Median,
              bold: true,
              alignment: 'center',
            });
            dtUMR.push({
              text: element.UMR,
              alignment: 'center',
            });
          }

          dtTable.table.body.push(dtHeader);
          dtTable.table.body.push(dtLMR);
          dtTable.table.body.push(dtMedian);
          dtTable.table.body.push(dtUMR);

          dataTrends.push(dtTable);
        } //end data trends

        {
          //start roc
          var roc = [
            {
              pageBreak: 'before',
              text: this.apiResponse.CompanyName,
              alignment: 'center',
              fontSize: 14,
              bold: true,
            },
            {
              text: 'Rates-of-Change',
              alignment: 'center',
              fontSize: 10,
              margin: [0, 0, 0, 5],
            },
          ];

          //add chart image
          roc.push({
            columnGap: 10,
            columns: [
              {
                // image: await this.$refs.roc.pushToImage(800, 500),
                image: $('#rocChartImg').attr('src'),
                width: 600,
                height: 400,
              },
              [
                {
                  width: 190,
                  height: 100,
                  image:
                    this.apiResponse.RoCPage.Phase === 'A'
                      ? 'pdfphaseAFrame'
                      : this.apiResponse.RoCPage.Phase === 'B'
                        ? 'pdfphaseBFrame'
                        : this.apiResponse.RoCPage.Phase === 'C'
                          ? 'pdfphaseCFrame'
                          : this.apiResponse.RoCPage.Phase === 'D'
                            ? 'pdfphaseDFrame'
                            : 'phaseNAFrame',
                  alignment: 'center',
                  margin: [0, 0, 0, 20],
                },
                {
                  text: 'Quarterly Growth (3/12)',
                  alignment: 'center',
                  fontSize: 14,
                  margin: [0, 0, 0, 10],
                },
                {
                  text: this.apiResponse.RoCPage.Last312,
                  alignment: 'center',
                  color: this.apiResponse.RoCPage.IsSwapped
                    ? '#183961'
                    : '#65A9D2',
                  bold: true,
                  fontSize: 16,
                  margin: [0, 0, 0, 20],
                },
                {
                  text: 'Annual Growth (12/12)',
                  alignment: 'center',
                  fontSize: 14,
                  margin: [0, 0, 0, 10],
                },
                {
                  text: this.apiResponse.RoCPage.Last1212,
                  alignment: 'center',
                  color: this.apiResponse.RoCPage.IsSwapped
                    ? '#65A9D2'
                    : '#183961',
                  bold: true,
                  fontSize: 16,
                  margin: [0, 0, 0, 20],
                },
                {
                  text: this.apiResponse.RoCPage.FirstTurningPointLabel,
                  alignment: 'center',
                  fontSize: 14,
                  margin: [0, 0, 0, 10],
                },
                {
                  text: this.apiResponse.RoCPage.FirstTurningPointQ,
                  alignment: 'center',
                  bold: true,
                  fontSize: 16,
                  margin: [0, 0, 0, 20],
                },
                {
                  text: this.apiResponse.RoCPage.SecondTurningPointLabel,
                  alignment: 'center',
                  fontSize: 14,
                  margin: [0, 0, 0, 10],
                },
                {
                  text: this.apiResponse.RoCPage.SecondTurningPointQ,
                  alignment: 'center',
                  bold: true,
                  fontSize: 16,
                  // margin: [0, 0, 0, 10]
                },
              ],
            ],
          });

          //add dt table
          var rocTable = {
            layout: 'lightHorizontalLines',
            margin: [0, 0, 0, 0],
            fontSize: 6,
            table: {
              headerRows: 1,
              widths: ['auto'],
              body: [],
              alignment: 'center',
            },
          };

          var rocHeader = [
            {
              text: this.apiResponse.RoCPage.RoCDetailTable.Row1Title,
              alignment: 'center',
            },
          ];
          var rocLMR = [
            {
              text: this.apiResponse.RoCPage.RoCDetailTable.Row2Title,
              alignment: 'center',
            },
          ];
          var rocMedian = [
            {
              text: this.apiResponse.RoCPage.RoCDetailTable.Row3Title,
              alignment: 'center',
              bold: true,
            },
          ];
          var rocUMR = [
            {
              text: this.apiResponse.RoCPage.RoCDetailTable.Row4Title,
              alignment: 'center',
            },
          ];
          //loop othrough dt data
          for (
            let i = 0;
            i < this.apiResponse.RoCPage.RoCDetailTable.Columns.length;
            i++
          ) {
            const element = this.apiResponse.RoCPage.RoCDetailTable.Columns[i];
            rocTable.table.widths.push('*');
            rocHeader.push({
              text: element.MonthYear,
              alignment: 'center',
            });
            rocLMR.push({
              text: element.LMR,
              alignment: 'center',
            });
            rocMedian.push({
              text: element.Median,
              bold: true,
              alignment: 'center',
            });
            rocUMR.push({
              text: element.UMR,
              alignment: 'center',
            });
          }

          rocTable.table.body.push(rocHeader);
          rocTable.table.body.push(rocLMR);
          rocTable.table.body.push(rocMedian);
          rocTable.table.body.push(rocUMR);

          roc.push(rocTable);
        } //end roc

        {
          //start divisions
          var divisions = [];
          for (let i = 0; i < this.apiResponse.RoCDivPages.length; ++i) {
            var division = [
              {
                pageBreak: 'before',
                text: this.apiResponse.RoCDivPages[i].PageTitle,
                alignment: 'center',
                fontSize: 14,
                bold: true,
              },
              {
                text:
                  this.apiResponse.RoCDivPages[i].OtherMetric +
                  ' Rates-of-Change',
                alignment: 'center',
                fontSize: 10,
                margin: [0, 0, 0, 0],
              },
            ];

            var divData = {
              columnGap: 10,
              columns: [
                {
                  // image: await this.$refs.division[i].pushToImage(800, 500),
                  image: $('#divisionChart' + i + 'ChartImg').attr('src'),
                  width: 600,
                  height: 400,
                },
                [
                  {
                    text: this.apiResponse.RoCDivPages[i].OtherSeriesName,
                    alignment: 'center',
                    margin: [0, 0, 0, 5],
                  },
                  {
                    width: 180,
                    // height: 100,
                    alignment: 'center',
                    margin: [0, 0, 0, 30],
                    image:
                      this.apiResponse.RoCDivPages[i].OtherPhase === 'A'
                        ? 'pdfphaseAFrame'
                        : this.apiResponse.RoCDivPages[i].OtherPhase === 'B'
                          ? 'pdfphaseBFrame'
                          : this.apiResponse.RoCDivPages[i].OtherPhase === 'C'
                            ? 'pdfphaseCFrame'
                            : this.apiResponse.RoCDivPages[i].OtherPhase === 'D'
                              ? 'pdfphaseDFrame'
                              : 'phaseNAFrame',
                  },
                  {
                    text: this.apiResponse.RoCDivPages[i].SubjectLabel,
                    alignment: 'center',
                    fontSize: 14,
                    margin: [0, 0, 0, 10],
                  },
                  {
                    text: this.apiResponse.RoCDivPages[i].SubjectLastData,
                    alignment: 'center',
                    color: '#183961',
                    bold: true,
                    fontSize: 16,
                    margin: [0, 0, 0, 30],
                  },
                  {
                    text: this.apiResponse.RoCDivPages[i].OtherLabel,
                    alignment: 'center',
                    fontSize: 14,
                    margin: [0, 0, 0, 10],
                  },
                  {
                    text: this.apiResponse.RoCDivPages[i].OtherLastData,
                    alignment: 'center',
                    color: '#EB6F2D',
                    bold: true,
                    fontSize: 16,
                    margin: [0, 0, 0, 30],
                  },
                ],
              ],
            };

            //add chart image
            division.push(divData);

            divisions.push(division);
          }
        } //end divisions

        {
          //forecast history
          if (this.apiResponse.FCHistoryPage !== null) {
            var forecastHistoryPage = [
              {
                pageBreak: 'before',
                columnGap: 5,
                columns: [
                  {
                    fit: [100, 100],
                    image: 'itrLogo',
                  },
                  {
                    width: '*',
                    alignment: 'center',
                    fontSize: 12,
                    bold: true,
                    text: [
                      this.apiResponse.FCHistoryPage.PageTitle +
                        ' Forecast History',
                    ],
                  },
                  {
                    fit: [100, 100],
                    alignment: 'right',
                    image: companyLogoImageDataUrl,
                  },
                ],
              },
            ];

            var wasRevised1ID = '';
            if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 ===
              'Rates-of-Change Adjusted'
            ) {
              wasRevised1ID = 'ratesOfChangeBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 ===
              'Data Trends Adjusted'
            ) {
              wasRevised1ID = 'dataTrendsBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 ===
              'Forecast Revised'
            ) {
              wasRevised1ID = 'forecastRevisedBar';
            }

            var wasRevised2ID = '';
            if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 ===
              'Rates-of-Change Adjusted'
            ) {
              wasRevised2ID = 'ratesOfChangeBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 ===
              'Data Trends Adjusted'
            ) {
              wasRevised2ID = 'dataTrendsBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 ===
              'Forecast Revised'
            ) {
              wasRevised2ID = 'forecastRevisedBar';
            }

            var wasRevised3ID = '';
            if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 &&
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 ===
                'Rates-of-Change Adjusted'
            ) {
              wasRevised3ID = 'ratesOfChangeBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 ===
              'Data Trends Adjusted'
            ) {
              wasRevised3ID = 'dataTrendsBar';
            } else if (
              this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 ===
              'Forecast Revised'
            ) {
              wasRevised3ID = 'forecastRevisedBar';
            }

            var forecastHistoryTable = {
              layout: 'lightHorizontalLines',
              margin: [0, 10, 0, 10],
              fontSize: 8,
              table: {
                headerRows: 1,
                alignment: 'center',
                widths: [],
                body: [],
              },
            };

            {
              // widths start
              var widths = ['*', '*'];
              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  null
              ) {
                widths.push('auto');
              }

              widths.push('*');

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  null
              ) {
                widths.push('auto');
              }

              widths.push('*');

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  null
              ) {
                widths.push('auto');
              }

              widths.push('*');

              forecastHistoryTable.table.widths = widths;
            } // widths end

            {
              // body start
              var body = [
                {
                  text: '',
                  color: '#FFF',
                  alignment: 'center',
                },
                {
                  text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header1,
                  alignment: 'center',
                },
              ];

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  null
              ) {
                body.push({
                  text: '',
                  color: '#FFF',
                  alignment: 'center',
                });
              }

              body.push({
                text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header2,
                alignment: 'center',
              });

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  null
              ) {
                body.push({
                  text: '',
                  color: '#FFF',
                  alignment: 'center',
                });
              }

              body.push({
                text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header3,
                alignment: 'center',
              });

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  null
              ) {
                body.push({
                  text: '',
                  color: '#FFF',
                  alignment: 'center',
                });
              }

              body.push({
                text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header4,
                alignment: 'center',
              });

              forecastHistoryTable.table.body.push(body);
            } // body end

            for (
              let i = 0;
              i < this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length;
              i++
            ) {
              const row = this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[i];
              var index = i;
              var actuals = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .FirstColumn
              );
              var lowerRange = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .FirstColumn
              );
              var upperRange = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .FirstColumn
              );
              var actualsSecond = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .SecondColumn
              );
              var lowerRangeSecond = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .SecondColumn
              );
              var upperRangeSecond = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .SecondColumn
              );
              var actualsThird = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .ThirdColumn
              );
              var lowerRangeThird = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .ThirdColumn
              );
              var upperRangeThird = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .ThirdColumn
              );
              var actualsFourth = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .FourthColumn
              );
              var lowerRangeFourth = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .FourthColumn
              );
              var upperRangeFourth = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .FourthColumn
              );

              var fcRow = [
                {
                  text: row.RowTitle,
                  bold: true,
                },
              ];

              if (row.RowTitle === 'Actual') {
                fcRow.push({
                  text: row.FirstColumn,
                  alignment: 'center',
                  bold: true,
                  color:
                    actuals >= lowerRange && actuals <= upperRange
                      ? '#09A684'
                      : '#D2232A',
                });
              } else {
                fcRow.push({
                  text: row.FirstColumn,
                  alignment: 'center',
                  bold:
                    i === 4 ||
                    i === 9 ||
                    row.RowTitle.includes('Annual') ||
                    row.RowTitle.includes('Quarterly') ||
                    (i > 10 && row.RowTitle === 'Actual')
                      ? true
                      : false,
                });
              }

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  null
              ) {
                fcRow.push({
                  fit: [100, 220],
                  image: this.getBase64Image(
                    document.getElementById(wasRevised1ID)
                  ),
                  rowSpan:
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >=
                    18
                      ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                          .length + 3
                      : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length >= 16
                        ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 3
                        : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 2,
                });
              }

              if (row.RowTitle === 'Actual') {
                fcRow.push({
                  text: row.SecondColumn,
                  alignment: 'center',
                  bold: true,
                  color:
                    actualsSecond >= lowerRangeSecond &&
                    actualsSecond <= upperRangeSecond
                      ? '#09A684'
                      : '#D2232A',
                });
              } else {
                fcRow.push({
                  text: row.SecondColumn,
                  alignment: 'center',
                  bold:
                    i === 4 ||
                    i === 9 ||
                    row.RowTitle.includes('Annual') ||
                    row.RowTitle.includes('Quarterly') ||
                    (i > 10 && row.RowTitle === 'Actual')
                      ? true
                      : false,
                });
              }

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  null
              ) {
                fcRow.push({
                  fit: [100, 220],
                  image: this.getBase64Image(
                    document.getElementById(wasRevised2ID)
                  ),
                  rowSpan:
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >=
                    18
                      ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                          .length + 3
                      : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length >= 16
                        ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 3
                        : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 2,
                });
              }

              if (row.RowTitle === 'Actual') {
                fcRow.push({
                  text: row.ThirdColumn,
                  alignment: 'center',
                  bold: true,
                  color:
                    actualsThird >= lowerRangeThird &&
                    actualsThird <= upperRangeThird
                      ? '#09A684'
                      : '#D2232A',
                });
              } else {
                fcRow.push({
                  text: row.ThirdColumn,
                  alignment: 'center',
                  bold:
                    i === 4 ||
                    i === 9 ||
                    row.RowTitle.includes('Annual') ||
                    row.RowTitle.includes('Quarterly') ||
                    (i > 10 && row.RowTitle === 'Actual')
                      ? true
                      : false,
                });
              }

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  null
              ) {
                fcRow.push({
                  fit: [100, 220],
                  image: this.getBase64Image(
                    document.getElementById(wasRevised3ID)
                  ),
                  rowSpan:
                    this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length >=
                    18
                      ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                          .length + 3
                      : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length >= 16
                        ? this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 3
                        : this.apiResponse.FCHistoryPage.FCHistoryTable.Rows
                            .length + 2,
                });
              }

              if (row.RowTitle === 'Actual') {
                fcRow.push({
                  text: row.FourthColumn,
                  alignment: 'center',
                  bold: true,
                  color:
                    actualsFourth >= lowerRangeFourth &&
                    actualsFourth <= upperRangeFourth
                      ? '#09A684'
                      : '#D2232A',
                });
              } else {
                fcRow.push({
                  text: row.FourthColumn,
                  alignment: 'center',
                  bold:
                    i === 4 ||
                    i === 9 ||
                    row.RowTitle.includes('Annual') ||
                    row.RowTitle.includes('Quarterly') ||
                    (i > 10 && row.RowTitle === 'Actual')
                      ? true
                      : false,
                });
              }

              forecastHistoryTable.table.body.push(fcRow);

              //push empty row if needed
              if (i === 4 || i === 9 || (i > 10 && row.RowTitle === 'Actual')) {
                var emptyRow = [
                  {
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                    alignment: 'center',
                  },
                  {
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                    alignment: 'center',
                  },
                ];

                if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                    '' &&
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                    null
                ) {
                  emptyRow.push({
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                    alignment: 'center',
                  });
                }

                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                  alignment: 'center',
                });

                if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                    '' &&
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                    null
                ) {
                  emptyRow.push({
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                    alignment: 'center',
                  });
                }

                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                  alignment: 'center',
                });

                if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                    '' &&
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                    null
                ) {
                  emptyRow.push({
                    text: '|',
                    fillColor: '#FFF',
                    color: '#FFF',
                    alignment: 'center',
                  });
                }

                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                  alignment: 'center',
                });

                forecastHistoryTable.table.body.push(emptyRow);
              }
            }

            forecastHistoryPage.push(forecastHistoryTable);

            var revisionHistoryText = {
              margin: [0, 0, 0, 10],
              fontSize: 10,
              table: {
                headerRows: 1,
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Forecast Revision History:',
                      fillColor: '#183961',
                      color: '#FFF',
                    },
                  ],
                ],
              },
              layout: {
                hLineColor: function () {
                  return '#183961';
                },
                vLineColor: function () {
                  return '#183961';
                },
              },
            };

            var revisionUL = [];
            for (
              let i = 0;
              i < this.apiResponse.FCHistoryPage.ForecastRevisions.length;
              i++
            ) {
              const element =
                this.apiResponse.FCHistoryPage.ForecastRevisions[i];
              revisionUL.push(element);
            }

            revisionHistoryText.table.body.push([
              {
                ul: revisionUL,
              },
            ]);
            forecastHistoryPage.push(revisionHistoryText);
          }
        } //forecast history end

        //terminology and methodology

        var termAndMethodology = [
          {
            pageBreak: 'before',
            image: 'termMethodology',
            width: 850,
            alignment: 'center',
            margin: [0, -100, 0, -50],
          },
        ];

        //indicator def
        var indicatorDefinitions = [
          {
            pageBreak: 'before',
            table: {
              widths: ['*'],
              header: 1,
              body: [
                [
                  {
                    text: 'Indicator Definitions',
                    color: '#FFF',
                    fillColor: '#3075A4',
                    alignment: 'center',
                    fontSize: 14,
                    bold: true,
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function () {
                return 1;
              },
              vLineWidth: function () {
                return 1;
              },
              hLineColor: function () {
                return '#3075A4';
              },
              vLineColor: function () {
                return '#3075A4';
              },
              paddingLeft: function () {
                return 40;
              },
              paddingRight: function () {
                return 40;
              },
              paddingTop: function () {
                return 5;
              },
              paddingBottom: function () {
                return 5;
              },
            },
          },
        ];

        var indicatorDefinitionsTable = {
          fontSize: 10,
          margin: [0, 0, 0, 10],
          table: {
            widths: ['*', '*'],
            body: [],
          },
          layout: {
            fillColor: function (rowIndex) {
              return rowIndex % 2 === 0 ? '#b8cce4' : null;
            },
            hLineWidth: function () {
              return 1;
            },
            vLineWidth: function () {
              return 1;
            },
          },
        };

        //loop through definitions and add
        for (
          let i = 0;
          i <
          this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows
            .length;
          ++i
        ) {
          var row =
            this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows[i];

          indicatorDefinitionsTable.table.body.push([
            { text: row.Name, margin: [0, 5, 0, 5] },
            { text: row.Definition, margin: [0, 5, 0, 5] },
          ]);
        }

        indicatorDefinitions.push(indicatorDefinitionsTable);

        var managementObjectives = [
          {
            pageBreak: 'before',
            image: 'managementObjectives',
            width: 850,
            alignment: 'center',
            margin: [0, -100, 0, -50],
          },
        ];

        var docDefinition = {
          pageOrientation: 'landscape',
          info: {
            title: this.apiResponse.companyName,
          },
          content: [
            coverPage,
            forecastPage,
            dataTrends,
            roc,
            divisions,
            this.apiResponse.FCHistoryPage !== null
              ? forecastHistoryPage
              : null,
            termAndMethodology,
            this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows
              .length > 0
              ? indicatorDefinitions
              : null,
            managementObjectives,
          ],
          footer: (currentPage) => {
            return {
              margin: [40, 20, 40, 0],
              columns: [
                {
                  text:
                    (currentPage === 1
                      ? document.getElementById('copyright').innerHTML +
                        this.currentYear
                      : '') +
                    ' ITR Economics' +
                    document.getElementById('tradeMark').innerHTML,
                  fontSize: 8,
                },
                {
                  text: this.apiResponse.CoverPage.ProductType,
                  fontSize: 8,
                  alignment: 'right',
                },
              ],
            };
          },
          styles: {
            blueBar: {
              background: '#3075A4',
              color: '#3075A4',
            },
            blueBarWText: {
              background: '#3075A4',
              color: '#FFF',
            },
            phaseA: {
              color: '#0A42D3',
              bold: true,
            },
            phaseB: {
              color: '#44AC4E',
              bold: true,
            },
            phaseC: {
              color: '#FF9916',
              bold: true,
            },
            phaseD: {
              color: '#D2232A',
              bold: true,
            },
            defaultTableTextColor: {
              color: '#A7A9AB',
              bold: true,
            },
            darkBlue: {
              color: '#2c4a6f',
            },
          },
          images: {
            pdfphaseAFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/pdfPhaseA.png',
            pdfphaseBFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/pdfPhaseB.png',
            pdfphaseCFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/pdfPhaseC.png',
            pdfphaseDFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/pdfPhaseD.png',

            phaseAFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-a-frame.png',
            phaseBFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-b-frame.png',
            phaseCFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-c-frame.png',
            phaseDFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-d-frame.png',
            phaseNAFrame:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-a-frame.png',
            phaseAFrameIndex:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/IndexA.png',
            phaseBFrameIndex:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/IndexB.png',
            phaseCFrameIndex:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/IndexC.png',
            phaseDFrameIndex:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/IndexD.png',
            phaseNAFrameIndex:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/IndexA.png',
            phaseAFull:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-a-full.png',
            phaseBFull:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-b-full.png',
            phaseCFull:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-c-full.png',
            phaseDFull:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/phase-d-full.png',
            guidePage:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/evp-360-guide.png',
            termMethodology:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/terminology-methodology.png',
            managementObjectives:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/management-objectives.png',
            itrLogo:
              window.location.protocol +
              '//' +
              window.location.host +
              '/images/logos/new/itr-corporate-logo-color-no-white-space.png',
          },
        };

        var pdf = pdfMake.createPdf(docDefinition);
        if (this.preview) {
          pdf.open();
        } else {
          pdf.download(this.companyName + '.pdf');
        }

        setTimeout(function () {
          $('#loadingFileModal').modal('hide');
        }, 5000);
      },
      async downloadPPT() {
        let pres = new pptxgen();
        const companyLogo = await this.getReportLogo();
        var companyName = this.apiResponse.CompanyName;

        let companyNameFontSize = 42;
        if (companyName.length >= 70) {
          companyNameFontSize = 10;
        } else if (companyName.length >= 40) {
          companyNameFontSize = 12;
        } else if (companyName.length >= 20) {
          companyNameFontSize = 22;
        } else if (companyName.length >= 15) {
          companyNameFontSize = 32;
        }

        for (let i = 0; i < this.apiResponse.RoCDivPages.length; ++i) {
          var pageTitleFontSize = 42;
          if (this.apiResponse.RoCDivPages[i].PageTitle.length >= 70) {
            pageTitleFontSize = 10;
          } else if (this.apiResponse.RoCDivPages[i].PageTitle.length >= 40) {
            pageTitleFontSize = 12;
          } else if (this.apiResponse.RoCDivPages[i].PageTitle.length >= 20) {
            pageTitleFontSize = 22;
          } else if (this.apiResponse.RoCDivPages[i].PageTitle.length >= 15) {
            pageTitleFontSize = 32;
          }
        }

        // this.apiResponse.RoCDivPages[i].SubjectLabel
        for (let i = 0; i < this.apiResponse.RoCDivPages.length; ++i) {
          var divTitleFontSize = 38;
          if (this.apiResponse.RoCDivPages[i].SubjectLabel.length >= 70) {
            divTitleFontSize = 10;
          } else if (
            this.apiResponse.RoCDivPages[i].SubjectLabel.length >= 40
          ) {
            divTitleFontSize = 12;
          } else if (
            this.apiResponse.RoCDivPages[i].SubjectLabel.length >= 20
          ) {
            divTitleFontSize = 22;
          } else if (
            this.apiResponse.RoCDivPages[i].SubjectLabel.length >= 15
          ) {
            divTitleFontSize = 32;
          }
        }

        // this.apiResponse.FCHistoryPage.PageTitle
        let fcHistoryTitleFontSize = 42;
        if (this.apiResponse.FCHistoryPage !== null) {
          if (this.apiResponse.FCHistoryPage.PageTitle.length >= 70) {
            fcHistoryTitleFontSize = 10;
          } else if (this.apiResponse.FCHistoryPage.PageTitle.length >= 40) {
            fcHistoryTitleFontSize = 12;
          } else if (this.apiResponse.FCHistoryPage.PageTitle.length >= 20) {
            fcHistoryTitleFontSize = 22;
          } else if (this.apiResponse.FCHistoryPage.PageTitle.length >= 15) {
            fcHistoryTitleFontSize = 32;
          }
        }

        {
          // Master Slide Start
          pres.defineSlideMaster({
            title: 'MASTER_SLIDE',
            background: { color: 'FFFFFF' },
            margin: '2',
            objects: [
              {
                image: {
                  w: '99%',
                  h: '100%',
                  y: '0%',
                  x: '1%',
                  data: this.getBase64Image(
                    document.getElementById('pptFooter')
                  ),
                },
              },
            ],
          });
        } // Master Slide End

        {
          // Cover Page Start
          let coverPageSlide = pres.addSlide();

          coverPageSlide.addImage({
            data: this.getBase64Image(
              document.getElementById('pptCoverBackground')
            ),
            h: '100%',
            w: '100%',
            y: '0%',
            x: '0%',
          });

          coverPageSlide.addImage({
            data: companyLogo,
            w: '25%',
            h: '25%',
            y: '5%',
            x: '50%',
            sizing: { type: 'cover' },
          });

          coverPageSlide.addText(companyName, {
            x: '33%',
            y: '40%',
            w: '65%',
            fontFace: 'Calibri',
            fontSize: companyNameFontSize,
            bold: true,
            color: '13355e',
            align: 'right',
          });

          coverPageSlide.addText(this.apiResponse.CoverPage.ProductType, {
            x: '23%',
            y: '56%',
            fontFace: 'Calibri',
            fontSize: '35',
            bold: true,
            color: '13355e',
            align: 'right',
          });

          coverPageSlide.addText(
            [
              {
                text: 'www.itrondemand.com',
                options: { hyperlink: { url: 'https://www.itrondemand.com' } },
              },
            ],
            {
              x: '56%',
              y: '70%',
              fontFace: 'Calibri',
              fontSize: '30',
              color: '13355e',
            }
          );

          coverPageSlide.addText('603.796.2500 • reports@itreconomics.com', {
            x: '45%',
            y: '91%',
            fontFace: 'Calibri',
            fontSize: '12',
            color: '13355e',
            align: 'center',
          });

          coverPageSlide.addText(
            '©' +
              ' ' +
              this.currentYear +
              ' ' +
              'ITR Economics' +
              document.getElementById('tradeMark').innerHTML +
              ' ' +
              'All Rights Reserved',
            {
              x: '45%',
              y: '94%',
              fontFace: 'Calibri',
              fontSize: '12',
              color: '13355e',
              align: 'center',
            }
          );
        } // Cover Page End

        {
          // Forecast Start
          if (this.forecastData !== null) {
            let forecastSlide = pres.addSlide({ masterName: 'MASTER_SLIDE' });
            forecastSlide.addText(this.forecastData.TableTitle + ' Forecast', {
              w: '100%',
              align: 'center',
              fontSize: 10,
              fontFace: 'Calibri',
              color: '386092',
              bold: true,
              y: '5%',
            });

            let forecastTableHeaders = [];
            for (
              let i = 0;
              i < this.forecastData.ForecastTable.Headers.length;
              ++i
            ) {
              if (this.forecastData.HideFirstColumn && i === 1) {
                if (
                  (i === 1 && this.forecastData.ForecastRevised) ||
                  (this.monthEnd[i] === this.forecastData.FiscalYearEndMonth &&
                    this.forecastData.ForecastTable.Headers.length - 1 !== i)
                ) {
                  forecastTableHeaders.push({
                    text: '',
                    options: { fontSize: 4 },
                  });
                }
              } else {
                let row = {
                  text: this.forecastData.ForecastTable.Headers[i],
                  options: {
                    align: i === 0 ? 'left' : 'center',
                    bold: true,
                    fontSize: 5,
                  },
                };
                forecastTableHeaders.push(row);

                if (
                  (i === 1 && this.forecastData.ForecastRevised) ||
                  (this.monthEnd[i] === this.forecastData.FiscalYearEndMonth &&
                    this.forecastData.ForecastTable.Headers.length - 1 !== i)
                ) {
                  forecastTableHeaders.push({
                    text: '',
                    options: { fontSize: 4 },
                  });
                }
              }
            }

            let rows = [];
            rows.push(forecastTableHeaders);

            // add row data
            for (
              let i = 0;
              i < this.forecastData.ForecastTable.Rows.length;
              ++i
            ) {
              var element = this.forecastData.ForecastTable.Rows[i];

              var fillColor = '';
              if (
                element.RowTitle.includes('Annual') ||
                element.RowTitle.includes('Quarterly')
              ) {
                fillColor = 'f2f2f2';
              }

              var boldRow = false;
              if (
                element.RowTitle === 'Actual' ||
                element.RowTitle.includes('Annual') ||
                element.RowTitle.includes('Quarterly')
              ) {
                boldRow = true;
              }

              var row = [
                {
                  text: this.forecastData.ForecastTable.Rows[i].RowTitle,
                  options: {
                    align: 'center',
                    fill: fillColor,
                    bold: boldRow,
                    fontSize: 5,
                  },
                },
              ];

              let y = 0;
              var additionalColumns = 0;
              for (
                let x = 0;
                x <
                this.forecastData.ForecastTable.Rows[i].ForecastColumns.length;
                ++x
              ) {
                const forecastData =
                  this.forecastData.ForecastTable.Rows[i].ForecastColumns[x];

                if (this.forecastData.HideFirstColumn && x === 0) continue;

                var actuals = parseFloat(
                  this.forecastData.ForecastTable.Rows[7].ForecastColumns[0]
                );
                var lowerRange = parseFloat(
                  this.forecastData.ForecastTable.Rows[4].ForecastColumns[0]
                );
                var upperRange = parseFloat(
                  this.forecastData.ForecastTable.Rows[6].ForecastColumns[0]
                );

                let fill = '';
                if (
                  element.RowTitle.includes('Annual') ||
                  element.RowTitle.includes('Quarterly')
                ) {
                  fill = 'f2f2f2';
                }

                let boldCol = false;
                if (
                  element.RowTitle === 'Actual' ||
                  element.RowTitle.includes('Annual') ||
                  element.RowTitle.includes('Quarterly')
                ) {
                  boldCol = true;
                }

                if (
                  (x === 1 && this.forecastData.ForecastRevised) ||
                  (this.monthEnd[x] === this.forecastData.FiscalYearEndMonth &&
                    this.forecastData.ForecastTable.Headers.length - 1 !== x)
                ) {
                  row.push({
                    text: '',
                    options: {
                      fill:
                        x === 1 && this.forecastData.ForecastRevised
                          ? ''
                          : fill,
                      fontSize: 5,
                    },
                  });
                  additionalColumns = ++y;
                }

                if (element.RowTitle === 'Actual') {
                  row.push({
                    text: forecastData,
                    options: {
                      align: 'center',
                      fontSize: 5,
                      bold: true,
                      color:
                        actuals >= lowerRange && actuals <= upperRange
                          ? '09A684'
                          : 'D2232A',
                    },
                  });
                } else {
                  row.push({
                    text: forecastData,
                    options: {
                      align: 'center',
                      fontSize: 5,
                      fill: fill,
                      bold: boldCol,
                    },
                  });
                }
              }

              rows.push(row);

              if (
                i > 0 &&
                this.forecastData.ForecastTable.Rows[i].RowTitle === 'Actual'
              ) {
                var blankRow = [
                  {
                    text: '',
                    options: {
                      border: { type: 'none' },
                      fontSize: 5,
                    },
                  },
                ];
                for (
                  let x = 0;
                  x <
                  this.forecastData.ForecastTable.Rows[i].ForecastColumns
                    .length +
                    additionalColumns;
                  ++x
                ) {
                  if (this.forecastData.HideFirstColumn && x === 0) continue;

                  blankRow.push({
                    text: '',
                    options: {
                      border: { type: 'none' },
                      fontSize: 5,
                    },
                  });
                }
                rows.push(blankRow);
              }
            }

            let b = 0;
            var simpleAdditionalColumns = 0;
            var blankRowIndex = [];
            for (
              let x = 0;
              x < this.forecastData.ForecastTable.Headers.length;
              ++x
            ) {
              if (x === 1 && this.forecastData.ForecastRevised) {
                simpleAdditionalColumns = ++b;
                blankRowIndex.push(x + simpleAdditionalColumns);
              } else if (
                this.monthEnd[x] === this.forecastData.FiscalYearEndMonth &&
                this.forecastData.ForecastTable.Headers.length - 1 !== x
              ) {
                simpleAdditionalColumns = ++b;
                blankRowIndex.push(x + simpleAdditionalColumns);
              }
            }

            var columnsSizes = [];
            for (
              let index = 0;
              index <
              this.forecastData.ForecastTable.Headers.length +
                simpleAdditionalColumns;
              index++
            ) {
              if (index === 0) {
                columnsSizes.push(1.5);
              } else if (blankRowIndex.includes(index)) {
                //check for blank row
                columnsSizes.push(0.1);
              } else {
                if (this.forecastData.HideFirstColumn && index === 1) continue;
                columnsSizes.push(0.365);
              }
            }

            var tablePosition =
              this.forecastData.ForecastTable.Headers.length <= 3
                ? '36%'
                : this.forecastData.ForecastTable.Headers.length <= 4
                  ? '34%'
                  : this.forecastData.ForecastTable.Headers.length <= 5
                    ? '32%'
                    : this.forecastData.ForecastTable.Headers.length <= 6
                      ? '30%'
                      : this.forecastData.ForecastTable.Headers.length <= 7
                        ? '28%'
                        : this.forecastData.ForecastTable.Headers.length <= 8
                          ? '26%'
                          : this.forecastData.ForecastTable.Headers.length <= 9
                            ? '24%'
                            : this.forecastData.ForecastTable.Headers.length <=
                                10
                              ? '22%'
                              : this.forecastData.ForecastTable.Headers
                                    .length <= 11
                                ? '20%'
                                : this.forecastData.ForecastTable.Headers
                                      .length <= 12
                                  ? '18%'
                                  : this.forecastData.ForecastTable.Headers
                                        .length <= 13
                                    ? '16%'
                                    : this.forecastData.ForecastTable.Headers
                                          .length <= 14
                                      ? '14%'
                                      : this.forecastData.ForecastTable.Headers
                                            .length <= 15
                                        ? '12%'
                                        : this.forecastData.ForecastTable
                                              .Headers.length <= 18
                                          ? '10%'
                                          : this.forecastData.ForecastTable
                                                .Headers.length <= 19
                                            ? '8%'
                                            : '0%';

            forecastSlide.addTable(rows, {
              align: 'center',
              y: '8%',
              x: tablePosition,
              border: { type: 'none' },
              autoPage: 'true',
              w: '90%',
              colW: columnsSizes,
              rowH: 0.01,
            });

            if (this.forecastData.ForecastRevised) {
              var revisedImage = '';
              if (
                this.forecastData.ForecastRevisedText === 'Forecast Revised'
              ) {
                revisedImage = this.getBase64Image(
                  document.getElementById('forecastRevisedBar')
                );
              } else if (
                this.forecastData.ForecastRevisedText === 'Data Trends Adjusted'
              ) {
                revisedImage = this.getBase64Image(
                  document.getElementById('dataTrendsBar')
                );
              } else if (
                this.forecastData.ForecastRevisedText ===
                'Rates-of-Change Adjusted'
              ) {
                revisedImage = this.getBase64Image(
                  document.getElementById('ratesOfChangeBar')
                );
              }

              if (revisedImage !== '') {
                var imagePosition =
                  this.forecastData.ForecastTable.Headers.length <= 3
                    ? this.forecastData.HideFirstColumn
                      ? '50.55%'
                      : '54.5%'
                    : this.forecastData.ForecastTable.Headers.length <= 4
                      ? this.forecastData.HideFirstColumn
                        ? '48.55%'
                        : '52.5%'
                      : this.forecastData.ForecastTable.Headers.length <= 5
                        ? this.forecastData.HideFirstColumn
                          ? '46.55%'
                          : '50.5%'
                        : this.forecastData.ForecastTable.Headers.length <= 6
                          ? this.forecastData.HideFirstColumn
                            ? '44.55%'
                            : '48.5%'
                          : this.forecastData.ForecastTable.Headers.length <= 7
                            ? this.forecastData.HideFirstColumn
                              ? '42.55%'
                              : '46.5%'
                            : this.forecastData.ForecastTable.Headers.length <=
                                8
                              ? this.forecastData.HideFirstColumn
                                ? '40.55%'
                                : '44.5%'
                              : this.forecastData.ForecastTable.Headers
                                    .length <= 9
                                ? this.forecastData.HideFirstColumn
                                  ? '38.55%'
                                  : '42.5%'
                                : this.forecastData.ForecastTable.Headers
                                      .length <= 10
                                  ? this.forecastData.HideFirstColumn
                                    ? '36.55%'
                                    : '40.5%'
                                  : this.forecastData.ForecastTable.Headers
                                        .length <= 11
                                    ? this.forecastData.HideFirstColumn
                                      ? '34.55%'
                                      : '38.5%'
                                    : this.forecastData.ForecastTable.Headers
                                          .length <= 12
                                      ? this.forecastData.HideFirstColumn
                                        ? '32.55%'
                                        : '36.5%'
                                      : this.forecastData.ForecastTable.Headers
                                            .length <= 13
                                        ? this.forecastData.HideFirstColumn
                                          ? '30.55%'
                                          : '34.5%'
                                        : this.forecastData.ForecastTable
                                              .Headers.length <= 14
                                          ? this.forecastData.HideFirstColumn
                                            ? '28.55%'
                                            : '32.5%'
                                          : this.forecastData.ForecastTable
                                                .Headers.length <= 15
                                            ? this.forecastData.HideFirstColumn
                                              ? '26.55%'
                                              : '30.5%'
                                            : this.forecastData.ForecastTable
                                                  .Headers.length <= 18
                                              ? this.forecastData
                                                  .HideFirstColumn
                                                ? '24.55%'
                                                : '28.5%'
                                              : this.forecastData.ForecastTable
                                                    .Headers.length <= 19
                                                ? this.forecastData
                                                    .HideFirstColumn
                                                  ? '22.55%'
                                                  : '26.5%'
                                                : this.forecastData
                                                      .HideFirstColumn
                                                  ? '14.5%'
                                                  : '18.4%'; //default placement

                forecastSlide.addImage({
                  data: revisedImage,
                  h: '65%',
                  w: '2%',
                  y: '0.5%',
                  x: imagePosition,
                });
              }
            }
          }
        } // Forecast End

        {
          // Forecast History Start
          if (this.apiResponse.FCHistoryPage !== null) {
            let forecastSlide = pres.addSlide({ masterName: 'MASTER_SLIDE' });
            forecastSlide.addText(
              this.apiResponse.FCHistoryPage.PageTitle + ' Forecast History',
              {
                w: '100%',
                align: 'center',
                fontSize: 10,
                fontFace: 'Calibri',
                color: '386092',
                bold: true,
                y: '5%',
              }
            );

            let forecastTableHeaders = [
              {
                text: '',
                options: { align: 'center', bold: true, fontSize: 6 },
              },
              {
                text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header1,
                options: { align: 'center', bold: true, fontSize: 6 },
              },
              {
                text: '',
                options: { fontSize: 6 },
              },
              {
                text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header2,
                options: { align: 'center', bold: true, fontSize: 6 },
              },
              {
                text: '',
                options: { fontSize: 6 },
              },
              {
                text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header3,
                options: { align: 'center', bold: true, fontSize: 6 },
              },
              {
                text: '',
                options: { fontSize: 6 },
              },
              {
                text: this.apiResponse.FCHistoryPage.FCHistoryTable.Header4,
                options: { align: 'center', bold: true, fontSize: 6 },
              },
            ];

            let rows = [];
            rows.push(forecastTableHeaders);

            // add row data
            for (
              let i = 0;
              i < this.apiResponse.FCHistoryPage.FCHistoryTable.Rows.length;
              ++i
            ) {
              let element =
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[i];

              var actualColorFirst = '';
              var actualColorSecond = '';
              var actualColorThird = '';
              var actualColorFourth = '';
              var actualsFirstColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .FirstColumn
              );
              var lowerRangeFirstColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .FirstColumn
              );
              var upperRangeFirstColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .FirstColumn
              );
              var actualsSecondColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .SecondColumn
              );
              var lowerRangeSecondColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .SecondColumn
              );
              var upperRangeSecondColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .SecondColumn
              );
              var actualsThirdColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .ThirdColumn
              );
              var lowerRangeThirdColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .ThirdColumn
              );
              var upperRangeThirdColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .ThirdColumn
              );
              var actualsFourthColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[8]
                  .FourthColumn
              );
              var lowerRangeFourthColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[5]
                  .FourthColumn
              );
              var upperRangeFourthColumn = parseFloat(
                this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[7]
                  .FourthColumn
              );

              if (element.RowTitle === 'Actual') {
                if (
                  actualsFirstColumn >= lowerRangeFirstColumn &&
                  actualsFirstColumn <= upperRangeFirstColumn
                ) {
                  actualColorFirst = '09A684';
                } else {
                  actualColorFirst = 'D2232A';
                }

                if (
                  actualsSecondColumn >= lowerRangeSecondColumn &&
                  actualsSecondColumn <= upperRangeSecondColumn
                ) {
                  actualColorSecond = '09A684';
                } else {
                  actualColorSecond = 'D2232A';
                }

                if (
                  actualsThirdColumn >= lowerRangeThirdColumn &&
                  actualsThirdColumn <= upperRangeThirdColumn
                ) {
                  actualColorThird = '09A684';
                } else {
                  actualColorThird = 'D2232A';
                }

                if (
                  actualsFourthColumn >= lowerRangeFourthColumn &&
                  actualsFourthColumn <= upperRangeFourthColumn
                ) {
                  actualColorFourth = '09A684';
                } else {
                  actualColorFourth = 'D2232A';
                }
              }

              var fillCol = '';
              if (
                element.RowTitle === 'Actual' ||
                element.RowTitle.includes('Annual') ||
                element.RowTitle.includes('Quarterly')
              ) {
                fillCol = 'f2f2f2';
              }

              var boldRow = false;
              if (
                i === 4 ||
                i === 9 ||
                element.RowTitle === 'Actual' ||
                element.RowTitle.includes('Annual') ||
                element.RowTitle.includes('Quarterly')
              ) {
                boldRow = true;
              }

              var row = [
                {
                  text: element.RowTitle,
                  options: {
                    align: 'center',
                    fill: fillCol,
                    bold: boldRow,
                    fontSize: 6,
                  },
                },
                {
                  text: element.FirstColumn,
                  options: {
                    align: 'center',
                    color: actualColorFirst,
                    fill: fillCol,
                    bold: boldRow,
                    fontSize: 6,
                  },
                },
                {
                  text: '',
                  options: {
                    align: 'center',
                    fill:
                      !this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised1 && fillCol !== ''
                        ? 'f2f2f2'
                        : '',
                    fontSize: 6,
                  },
                },
                {
                  text: this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[i]
                    .SecondColumn,
                  options: {
                    align: 'center',
                    color: actualColorSecond,
                    fill: fillCol,
                    bold: boldRow,
                    fontSize: 6,
                  },
                },
                {
                  text: '',
                  options: {
                    align: 'center',
                    fill:
                      !this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised2 && fillCol !== ''
                        ? 'f2f2f2'
                        : '',
                    fontSize: 6,
                  },
                },
                {
                  text: this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[i]
                    .ThirdColumn,
                  options: {
                    align: 'center',
                    color: actualColorThird,
                    fill: fillCol,
                    bold: boldRow,
                    fontSize: 6,
                  },
                },
                {
                  text: '',
                  options: {
                    align: 'center',
                    fill:
                      !this.apiResponse.FCHistoryPage.FCHistoryTable
                        .WasRevised3 && fillCol !== ''
                        ? 'f2f2f2'
                        : '',
                    fontSize: 6,
                  },
                },
                {
                  text: this.apiResponse.FCHistoryPage.FCHistoryTable.Rows[i]
                    .FourthColumn,
                  options: {
                    align: 'center',
                    color: actualColorFourth,
                    fill: fillCol,
                    bold: boldRow,
                    fontSize: 6,
                  },
                },
              ];

              var fcHColumnSizes = [
                1.75, 1.75, 0.4, 1.75, 0.4, 1.75, 0.4, 1.75,
              ];

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 !==
                  null
              ) {
                if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 ===
                  'Forecast Revised'
                ) {
                  forecastSlide.addImage({
                    data: this.getBase64Image(
                      document.getElementById('forecastRevisedBar')
                    ),
                    h: '65%',
                    w: '2%',
                    y: '0.5%',
                    x: '36.2%',
                  });
                } else if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 ===
                  'Data Trends Adjusted'
                ) {
                  forecastSlide.addImage({
                    data: this.getBase64Image(
                      document.getElementById('dataTrendsBar')
                    ),
                    h: '65%',
                    w: '2%',
                    y: '0.5%',
                    x: '36.2%',
                  });
                } else if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised1 ===
                  'Rates-of-Change Adjusted'
                ) {
                  forecastSlide.addImage({
                    data: this.getBase64Image(
                      document.getElementById('ratesOfChangeBar')
                    ),
                    h: '65%',
                    w: '2%',
                    y: '0.5%',
                    x: '36.2%',
                  });
                }
              }

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 !==
                  null
              ) {
                if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 ===
                  'Forecast Revised'
                ) {
                  forecastSlide.addImage({
                    data: this.getBase64Image(
                      document.getElementById('forecastRevisedBar')
                    ),
                    h: '65%',
                    w: '2%',
                    y: '0.5%',
                    x: '57.5%',
                  });
                } else if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 ===
                  'Data Trends Adjusted'
                ) {
                  forecastSlide.addImage({
                    data: this.getBase64Image(
                      document.getElementById('dataTrendsBar')
                    ),
                    h: '65%',
                    w: '2%',
                    y: '0.5%',
                    x: '57.5%',
                  });
                } else if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised2 ===
                  'Rates-of-Change Adjusted'
                ) {
                  forecastSlide.addImage({
                    data: this.getBase64Image(
                      document.getElementById('ratesOfChangeBar')
                    ),
                    h: '65%',
                    w: '2%',
                    y: '0.5%',
                    x: '57.5%',
                  });
                }
              }

              if (
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  '' &&
                this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 !==
                  null
              ) {
                if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 ===
                  'Forecast Revised'
                ) {
                  forecastSlide.addImage({
                    data: this.getBase64Image(
                      document.getElementById('forecastRevisedBar')
                    ),
                    h: '65%',
                    w: '2%',
                    y: '0.5%',
                    x: '78.9%',
                  });
                } else if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 ===
                  'Data Trends Adjusted'
                ) {
                  forecastSlide.addImage({
                    data: this.getBase64Image(
                      document.getElementById('dataTrendsBar')
                    ),
                    h: '65%',
                    w: '2%',
                    y: '0.5%',
                    x: '78.9%',
                  });
                } else if (
                  this.apiResponse.FCHistoryPage.FCHistoryTable.WasRevised3 ===
                  'Rates-of-Change Adjusted'
                ) {
                  forecastSlide.addImage({
                    data: this.getBase64Image(
                      document.getElementById('ratesOfChangeBar')
                    ),
                    h: '65%',
                    w: '2%',
                    y: '0.5%',
                    x: '78.9%',
                  });
                }
              }

              rows.push(row);

              if (
                i === 4 ||
                i === 9 ||
                (i > 10 && element.RowTitle === 'Actual')
              ) {
                var blankRow = [
                  {
                    text: '',
                    border: { type: 'none' },
                    options: { fontSize: 2 },
                  },
                  {
                    text: '',
                    border: { type: 'none' },
                    options: { fontSize: 2 },
                  },
                  {
                    text: '',
                    border: { type: 'none' },
                    options: { fontSize: 2 },
                  },
                  {
                    text: '',
                    border: { type: 'none' },
                    options: { fontSize: 2 },
                  },
                  {
                    text: '',
                    border: { type: 'none' },
                    options: { fontSize: 2 },
                  },
                  {
                    text: '',
                    border: { type: 'none' },
                    options: { fontSize: 2 },
                  },
                  {
                    text: '',
                    border: { type: 'none' },
                    options: { fontSize: 2 },
                  },
                  {
                    text: '',
                    border: { type: 'none' },
                    options: { fontSize: 2 },
                  },
                ];

                rows.push(blankRow);
              }
            }

            forecastSlide.addTable(rows, {
              align: 'center',
              y: '8%',
              x: '0%',
              border: { type: 'none' },
              autoPage: 'true',
              w: '100%',
              rowH: 0.2,
              colW: fcHColumnSizes,
            });
          }
        } // Forecast History End

        {
          // Data Trends Start
          let dataTrendsSlide = pres.addSlide({ masterName: 'MASTER_SLIDE' });

          dataTrendsSlide.addText(this.apiResponse.DataTrendsPage.CompanyName, {
            w: '100%',
            align: 'center',
            fontSize: 10,
            fontFace: 'Calibri',
            color: '386092',
            bold: true,
            y: '5%',
          });

          dataTrendsSlide.addText(
            'Data Trends, ' + this.apiResponse.DataTrendsPage.DataLabel,
            {
              w: '100%',
              align: 'center',
              fontSize: '10',
              fontFace: 'Calibri',
              y: '10%',
            }
          );

          dataTrendsSlide.addImage({
            data: $('#dataTrendsChartImg').attr('src'),
            h: '50%',
            w: '55%',
            y: '12%',
            x: '23%',
          });

          //add dt table
          var dtHeader = [
            {
              text: this.apiResponse.DataTrendsPage.DataTrendsTable.Row1Title,
              options: { align: 'center', bold: false, fontSize: 6 },
            },
          ];
          var dtLMR = [
            {
              text: this.apiResponse.DataTrendsPage.DataTrendsTable.Row2Title,
              options: { align: 'center', bold: false, fontSize: 6 },
            },
          ];
          var dtMedian = [
            {
              text: this.apiResponse.DataTrendsPage.DataTrendsTable.Row3Title,
              options: {
                align: 'center',
                fill: 'f2f2f2',
                bold: true,
                fontSize: 6,
              },
            },
          ];
          var dtUMR = [
            {
              text: this.apiResponse.DataTrendsPage.DataTrendsTable.Row4Title,
              options: { align: 'center', bold: false, fontSize: 6 },
            },
          ];

          var columnsSizes = [1.5];
          for (
            let i = 0;
            i < this.apiResponse.DataTrendsPage.DataTrendsTable.Columns.length;
            i++
          ) {
            const element =
              this.apiResponse.DataTrendsPage.DataTrendsTable.Columns[i];
            // dtTable.table.widths.push("auto");
            dtHeader.push({
              text: element.MonthYear,
              options: { align: 'center', bold: false, fontSize: 6 },
            });
            dtLMR.push({
              text: element.LMR,
              options: { align: 'center', bold: false, fontSize: 6 },
            });
            dtMedian.push({
              text: element.Median,
              options: {
                align: 'center',
                fill: 'f2f2f2',
                bold: true,
                fontSize: 6,
              },
            });
            dtUMR.push({
              text: element.UMR,
              options: { align: 'center', bold: false, fontSize: 6 },
            });

            columnsSizes.push(0.42);
          }

          let dtTable = [];

          dtTable.push(dtHeader);
          dtTable.push(dtLMR);
          dtTable.push(dtMedian);
          dtTable.push(dtUMR);

          var dtPosition =
            columnsSizes.length <= 2
              ? '40%'
              : columnsSizes.length <= 3
                ? '36%'
                : columnsSizes.length <= 4
                  ? '34%'
                  : columnsSizes.length <= 5
                    ? '32%'
                    : columnsSizes.length <= 6
                      ? '30%'
                      : columnsSizes.length <= 7
                        ? '28%'
                        : columnsSizes.length <= 8
                          ? '26%'
                          : columnsSizes.length <= 9
                            ? '24%'
                            : columnsSizes.length <= 10
                              ? '20%'
                              : columnsSizes.length <= 11
                                ? '16%'
                                : columnsSizes.length <= 12
                                  ? '15%'
                                  : columnsSizes.length <= 13
                                    ? '14%'
                                    : columnsSizes.length <= 14
                                      ? '13%'
                                      : columnsSizes.length <= 15
                                        ? '12%'
                                        : columnsSizes.length <= 16
                                          ? '11%'
                                          : columnsSizes.length <= 17
                                            ? '10%'
                                            : columnsSizes.length <= 18
                                              ? '9%'
                                              : columnsSizes.length <= 19
                                                ? '8%'
                                                : '0%';

          dataTrendsSlide.addTable(dtTable, {
            align: 'center',
            y: '65%',
            x: dtPosition,
            border: { type: 'none' },
            autoPage: 'true',
            colW: columnsSizes,
          });
        } // Data Trends End

        {
          // ROC Start
          let rocSlide = pres.addSlide({ masterName: 'MASTER_SLIDE' });

          rocSlide.addText(this.apiResponse.CompanyName, {
            w: '100%',
            align: 'center',
            fontSize: 10,
            fontFace: 'Calibri',
            color: '386092',
            bold: true,
            y: '5%',
          });

          rocSlide.addText('Rates-of-Change', {
            w: '100%',
            align: 'center',
            fontSize: '10',
            fontFace: 'Calibri',
            y: '10%',
          });

          rocSlide.addImage({
            data: $('#rocChartImg').attr('src'),
            h: '50%',
            w: '55%',
            align: 'center',
            y: '15%',
            x: '23%',
          });

          var rocHeader = [
            {
              text: this.apiResponse.RoCPage.RoCDetailTable.Row1Title,
              options: { align: 'center', bold: false, fontSize: 6 },
            },
          ];
          var rocLMR = [
            {
              text: this.apiResponse.RoCPage.RoCDetailTable.Row2Title,
              options: { align: 'center', bold: false, fontSize: 6 },
            },
          ];
          var rocMedian = [
            {
              text: this.apiResponse.RoCPage.RoCDetailTable.Row3Title,
              options: {
                align: 'center',
                fill: 'f2f2f2',
                bold: true,
                fontSize: 6,
              },
            },
          ];
          var rocUMR = [
            {
              text: this.apiResponse.RoCPage.RoCDetailTable.Row4Title,
              options: { align: 'center', bold: false, fontSize: 6 },
            },
          ];
          var columnsSizes = [1.5];

          //loop othrough dt data
          for (
            let i = 0;
            i < this.apiResponse.RoCPage.RoCDetailTable.Columns.length;
            i++
          ) {
            const element = this.apiResponse.RoCPage.RoCDetailTable.Columns[i];
            // rocTable.table.widths.push("auto");
            rocHeader.push({
              text: element.MonthYear,
              options: { align: 'center', bold: false, fontSize: 6 },
            });
            rocLMR.push({
              text: element.LMR,
              options: { align: 'center', bold: false, fontSize: 6 },
            });
            rocMedian.push({
              text: element.Median,
              options: {
                align: 'center',
                fill: 'f2f2f2',
                bold: true,
                fontSize: 6,
              },
            });
            rocUMR.push({
              text: element.UMR,
              options: { align: 'center', bold: false, fontSize: 6 },
            });

            columnsSizes.push(0.42);
          }

          let rocTable = [];

          rocTable.push(rocHeader);
          rocTable.push(rocLMR);
          rocTable.push(rocMedian);
          rocTable.push(rocUMR);

          var rocPosition =
            columnsSizes.length <= 2
              ? '40%'
              : columnsSizes.length <= 3
                ? '36%'
                : columnsSizes.length <= 4
                  ? '34%'
                  : columnsSizes.length <= 5
                    ? '32%'
                    : columnsSizes.length <= 6
                      ? '30%'
                      : columnsSizes.length <= 7
                        ? '28%'
                        : columnsSizes.length <= 8
                          ? '26%'
                          : columnsSizes.length <= 9
                            ? '24%'
                            : columnsSizes.length <= 10
                              ? '20%'
                              : columnsSizes.length <= 11
                                ? '16%'
                                : columnsSizes.length <= 12
                                  ? '15%'
                                  : columnsSizes.length <= 13
                                    ? '14%'
                                    : columnsSizes.length <= 14
                                      ? '13%'
                                      : columnsSizes.length <= 15
                                        ? '12%'
                                        : columnsSizes.length <= 16
                                          ? '11%'
                                          : columnsSizes.length <= 17
                                            ? '10%'
                                            : columnsSizes.length <= 18
                                              ? '9%'
                                              : columnsSizes.length <= 19
                                                ? '8%'
                                                : '0%';

          rocSlide.addTable(rocTable, {
            align: 'center',
            y: '65%',
            x: rocPosition,
            border: { type: 'none' },
            autoPage: 'true',
            w: '100%',
            colW: columnsSizes,
          });
        } // ROC End

        {
          // ROC Div Start
          if (this.apiResponse.RoCDivPages) {
            for (let i = 0; i < this.apiResponse.RoCDivPages.length; ++i) {
              let divisionComparisonSlide = pres.addSlide({
                masterName: 'MASTER_SLIDE',
              });

              divisionComparisonSlide.addText(
                this.apiResponse.RoCDivPages[i].PageTitle,
                {
                  w: '100%',
                  align: 'center',
                  fontSize: pageTitleFontSize,
                  fontFace: 'Calibri',
                  color: '386092',
                  bold: true,
                  y: '5%',
                }
              );

              // divisionComparisonSlide.addText( this.apiResponse.RoCDivPages[i].SubjectLabel, { w: '100%', align: 'center', fontSize: divTitleFontSize, fontFace: 'Calibri', y: '10%' });

              let division_img = $('#divisionChart' + i + 'ChartImg').attr(
                'src'
              );
              divisionComparisonSlide.addImage({
                data: division_img,
                h: '70%',
                w: '70%',
                align: 'center',
                y: '15%',
                x: '15%',
              });
            }
          }
        } // ROC Div End

        pres.writeFile(this.companyName + '.pptx').then(() => {
          $('#loadingFileModal').modal('hide');
        });
      },
      getBase64Image: function (img) {
        if (img) {
          var canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          var dataURL = canvas.toDataURL('image/png');
          // return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
          return dataURL;
        }
      },
      async createCoverPageChart() {
        let trace = {
          type: 'scatter',
          mode: 'scatter',
          x: this.apiResponse.CoverPage.MonthYear,
          y: this.apiResponse.CoverPage.HistoricData,
          line: {
            width: 4,
            color: '#183961',
          },
          yaxis: 'y1',
          xaxis: 'x',
          visible: true,
        };

        let fcLMRTrace = {
          mode: 'lines',
          x: this.apiResponse.CoverPage.MonthYear,
          y: this.apiResponse.CoverPage.LMRForecast,
          line: {
            width: 4,
            color: '#183961',
            dash: 'dashdot',
          },
          yaxis: 'y1',
          xaxis: 'x',
          visible: false,
        };

        let fcUMRTrace = {
          mode: 'lines',
          x: this.apiResponse.CoverPage.MonthYear,
          y: this.apiResponse.CoverPage.UMRForecast,
          line: {
            width: 4,
            color: '#183961',
            dash: 'dashdot',
          },
          yaxis: 'y1',
          xaxis: 'x',
          visible: false,
        };

        for (let i = 0; i < this.apiResponse.CoverPage.MonthYear.length; i++) {
          // const element = this.apiResponse.CoverPage.MonthYear[i];

          if (this.apiResponse.CoverPage.LMRForecast) {
            fcLMRTrace.visible = true;
          }

          if (this.apiResponse.CoverPage.UMRForecast) {
            fcUMRTrace.visible = true;
          }
        }

        //array of all traces to plot
        let chartData = [trace, fcLMRTrace, fcUMRTrace];

        const layout = {
          showlegend: false,
          autosize: true,
          dragmode: 'zoom',
          yaxis: {
            anchor: 'x',
            family: '\\"Open Sans\\", sans-serif',
            size: 12,
            color: '#444',
            automargin: true,
            showgrid: false,
            showline: false,
            showticklabels: false,
          },

          xaxis: {
            dtick: 'M24',
            automargin: true,
            showgrid: false,
            showline: false,
            showticklabels: false,
          },
          family: '\\"Open Sans\\", sans-serif',
          size: 12,
          color: '#444',
          height: 650,
          margin: {
            t: 50,
            l: 50,
            r: 50,
            b: 50,
          },
        };
        await Plotly.newPlot('coverPageChart', chartData, layout, {
          responsive: true,
          displaylogo: false,
          modeBarButtonsToRemove: [
            'autoScale2d',
            'toImage',
            'sendDataToCloud',
            'lasso2d',
            'toggleSpikelines',
            'resetScale2d',
          ],
          doubleClick: false /*'reset'*/,
        });
      },
      buildEmptyForecastRow() {
        var emptyRow = [];
        for (
          let i = 0;
          i < this.apiResponse.ForecastTablePage.ForecastTable.Headers.length;
          i++
        ) {
          const element =
            this.apiResponse.ForecastTablePage.ForecastTable.Headers[i];
          var headerIndex = i;
          var fiscalMonthEnd =
            this.apiResponse.ForecastTablePage.FiscalYearEndMonth;
          var monthEnd = this.monthEnd[headerIndex];

          if (i === 1 && this.apiResponse.ForecastTablePage.HideFirstColumn) {
            if (
              headerIndex === 1 &&
              this.apiResponse.ForecastTablePage.ForecastRevised
            ) {
              if (
                monthEnd === fiscalMonthEnd &&
                this.apiResponse.ForecastTablePage.ForecastTable.Headers
                  .length -
                  1 !==
                  headerIndex
              ) {
                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                });
              } else {
                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                });
              }
            } else if (
              monthEnd === fiscalMonthEnd &&
              this.apiResponse.ForecastTablePage.ForecastTable.Headers.length -
                1 !==
                headerIndex
            ) {
              emptyRow.push({
                text: '|',
                fillColor: '#FFF',
                color: '#FFF',
              });
            }
          } else {
            if (
              headerIndex === 1 &&
              this.apiResponse.ForecastTablePage.ForecastRevised
            ) {
              if (
                monthEnd === fiscalMonthEnd &&
                this.apiResponse.ForecastTablePage.ForecastTable.Headers
                  .length -
                  1 !==
                  headerIndex
              ) {
                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                });
              } else {
                emptyRow.push({
                  text: '|',
                  fillColor: '#FFF',
                  color: '#FFF',
                });
              }
            } else if (
              monthEnd === fiscalMonthEnd &&
              this.apiResponse.ForecastTablePage.ForecastTable.Headers.length -
                1 !==
                headerIndex
            ) {
              emptyRow.push({
                text: '|',
                fillColor: '#FFF',
                color: '#FFF',
              });
            }

            emptyRow.push({
              text: '|',
              fillColor: '#FFF',
              color: '#FFF',
            });
          }
        }

        return emptyRow;
      },
    },
  };
</script>
